import * as AdminTasksModule from './index';

export const Admin_Tasks = {
  path: '/admin/tasks',
  name: 'AdminTasks',
  component: AdminTasksModule.AdminTasks,
};

export const Admin_CreateTask = {
  path: '/admin/createtask',
  name: 'AdminCreateTask',
  component: AdminTasksModule.AdminCreateTask,
};

export const Admin_SubTasks = {
  path: '/admin/subtasks',
  name: 'AdminSubTasks',
  component: AdminTasksModule.AdminSubTasks,
};
